import React from 'react';
import { Outlet, Navigate } from 'react-router';

import { useRBAC, useIsLoggedInUser } from 'providers/auth';

export default function PolicyEnforcer(props) {
  const { userCan } = useRBAC();
  const isLoggedIn = useIsLoggedInUser();

  // If the user is not logged in and somehow ended on this page, don't return any content.
  // Redirecting will be taken care of in the layouts/private component.
  if (isLoggedIn.data !== true) {
    return null;
  }

  const policies = props?.policies ?? [];

  // No policies defined, redirect away from this route
  if (Array.isArray(policies) === false || policies.length === 0) {
    return <Navigate to='/forbidden' />;
  }

  // Check if the user has the right policies to access the route
  let hasAccess = false;

  for (const policy of policies) {
    const resource = policy?.resource ?? '';
    const action = policy?.action ?? '';

    if (typeof resource !== 'string' || typeof action !== 'string') {
      continue;
    }

    if (resource.length === 0 || action.length === 0) {
      continue;
    }

    if (userCan(resource, action) === true) {
      hasAccess = true;
      break;
    }
  }

  // If the user doesn't have access to this resource then redirect to the forbidden page
  if (hasAccess !== true) {
    return <Navigate to='/forbidden' />;
  }

  return <Outlet />;
}
